const validateForm = form => {
	const formData = new FormData(form);
	const errorFields = [];

	form?.querySelectorAll("[data-required]")?.forEach(item => {
		const formFieldName = item.querySelector("*[name]")?.getAttribute("name");
		const fieldValue = formData.get(formFieldName);
		let error = false;

		const isCheckbox =
			item?.querySelector(`*[name="${formFieldName}"]`)?.getAttribute("type") === "checkbox";

		if (typeof fieldValue === "object" && fieldValue !== null) {
			// type === upload -> check name

			if (fieldValue?.name === "") {
				error = true;
			}
		} else if (isCheckbox) {
			error = fieldValue === null;
		} else {
			if (!fieldValue) {
				error = true;
			}
		}

		if (error) {
			errorFields.push(formFieldName);
			item.setAttribute("data-validation-error", "");
		} else {
			item.removeAttribute("data-validation-error");
		}
	});

	return {
		error: errorFields.length > 0,
		errorFields
	};
};

export default validateForm;
